var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"max-with":"300px","min-with":"300px"}},[_c('div',{attrs:{"id":"chart"}})])}]

export { render, staticRenderFns }